import { render, staticRenderFns } from "./GeneralDatatables.vue?vue&type=template&id=00f21f3d&"
import script from "./GeneralDatatables.vue?vue&type=script&lang=js&"
export * from "./GeneralDatatables.vue?vue&type=script&lang=js&"
import style0 from "../vendor/DataTables/DataTables-1.10.20/css/dataTables.bootstrap4.css?vue&type=style&index=0&lang=css&"
import style1 from "../vendor/DataTables/DataTables-1.10.20/css/jquery.dataTables.min.css?vue&type=style&index=1&lang=css&"
import style2 from "../vendor/DataTables/ColReorder-1.5.2/css/colReorder.dataTables.min.css?vue&type=style&index=2&lang=css&"
import style3 from "./GeneralDatatables.vue?vue&type=style&index=3&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports